import { render, staticRenderFns } from "./DocumentAccordion.vue?vue&type=template&id=5da9b1fe&scoped=true"
import script from "./DocumentAccordion.vue?vue&type=script&lang=js"
export * from "./DocumentAccordion.vue?vue&type=script&lang=js"
import style0 from "./DocumentAccordion.vue?vue&type=style&index=0&id=5da9b1fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da9b1fe",
  null
  
)

export default component.exports